import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {RadioButtonDto} from "./dto/radio-button.dto";
import {FormItem} from "../../modules/feedback/repository/entity/feedback.entity";

@Component({
  selector: 'shared-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrl: './radio-button.component.scss',
})
export class RadioButtonComponent implements OnInit {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() config: RadioButtonDto;
  @Input() items: FormItem[];
  @Output() value = new EventEmitter<string>();
  @Output() otherValue = new EventEmitter<string>();
  valueSet: any;
  otherValueSet: string;
  @ViewChild('notesEl') notesEl: ElementRef;
  constructor() {}

  ngOnInit(): void {
    if (this.config === undefined) {
      this.config = {isRequired: false, initialValue: "", initialOtherValue: "", withOtherValue: false, isRequiredOtherValue: false}
    }
    if (this.config.initialOtherValue) {
      this.otherValueSet = this.config.initialOtherValue
    }

    if (this.config.initialValue) {
      this.valueSet = this.config.initialValue
    }
  }

  onChangeValue(value: string): void {
    this.value.emit(value)
  }
  onChangeOtherValue(value: string): void {
    this.otherValue.emit(value)
  }
}
